import { ReactElement, useMemo, useCallback, useState, useEffect } from 'react';

import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Button, GoBackButton } from '~/components';
import { ExLibraryModal } from '~/components/ExLibraryModal';
import { useLoading } from '~/hooks/loading';
import { ISegments } from '~/models/Exercise';
import { ExerciseService } from '~/services';

import * as S from './styles';

function Exercises(): ReactElement {
  const { setLoading } = useLoading();
  const router = useHistory();
  const [segments, setSegments] = useState<ISegments[]>([]);
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

  const handleGoExercisesList = useCallback(
    (exerciseArea: string) => {
      router.push(`/ilab/exercises/list/${exerciseArea}`);
    },
    [router],
  );

  const handleGetSegments = useCallback(async () => {
    try {
      setLoading(true);

      const response = await ExerciseService.getAllSegments();

      setSegments(response.data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Ocorreu um problema ao carregar os dados!');
    }
  }, []);

  useEffect(() => {
    handleGetSegments();
  }, [handleGetSegments, modalIsOpen]);

  const ExercisesMenuMemo = useMemo(
    () =>
      segments.map(({ muscle_segment }) => (
        <S.ExercisesMenuItem key={muscle_segment}>
          <S.ExercisesMenuLink
            onClick={() => handleGoExercisesList(muscle_segment)}
          >
            {muscle_segment} <span>{'>'}</span>
          </S.ExercisesMenuLink>
        </S.ExercisesMenuItem>
      )),
    [handleGoExercisesList, segments],
  );

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.ExercisesMenu>{ExercisesMenuMemo}</S.ExercisesMenu>
        <Button
          variant="border"
          extraStyles={{
            borderColor: '#FFDF22',
            backgroundColor: '#FFDF22',
            width: '520px',
          }}
          onClick={() => setModalIsOpen(true)}
          textContent="Cadastrar"
          textColor="#000"
        />
      </S.Container>
      <ExLibraryModal
        modalVisible={modalIsOpen}
        setModalVisible={setModalIsOpen}
        title="CADASTRAR NOVA CATEGORIA DE DADOS"
        modalType="addCategory"
      />
    </>
  );
}

export default Exercises;
